/**
 * WHA-3270 — stored name of the system-managed folder that holds files uploaded
 * through an issue's attachment flow. The database reserves it per project; on
 * screen it is shown under a localised name (`tagIssueAttachmentsFolder`).
 */
export const ISSUE_ATTACHMENTS_FOLDER_NAME = "Issue Attachments";
